import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../Theme/theme';

export const s = StyleSheet.create({
	grid: {
		display: 'grid',
		gridTemplateColumns: 'repeat(4, 1fr)',
		gap: SPACE[16],
		[THEME.queries.lg]: {
			gridTemplateColumns: 'repeat(3, 1fr)',
		},
		[THEME.queries.sm]: {
			gridTemplateColumns: 'repeat(2, 1fr)',
		},
	},
	card: {
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		overflow: 'hidden',
		backgroundColor: THEME.colors.background.main,
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		':hover': {
			borderColor: THEME.colors.primary.main,
		},
	},
	// Neutralises the shared Button chrome so the thumbnail fills the card edge to edge.
	cardImageButton: {
		padding: 0,
		borderRadius: 0,
		display: 'block',
		width: '100%',
		height: 'auto',
	},
	cardNameRow: {
		flex: 1,
		minWidth: 0,
		padding: `${SPACE[4]}px ${SPACE[8]}px`,
	},
	cardNameInput: {
		width: '100%',
		fontSize: THEME.typography.fontSizes.xs,
	},
	cardNameButton: {
		cursor: 'text',
		flex: 1,
		minWidth: 0,
		display: 'block',
		width: '100%',
		height: 'auto',
		borderRadius: 0,
		padding: `${SPACE[4]}px ${SPACE[8]}px`,
		textAlign: 'left',
		justifyContent: 'flex-start',
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
		...THEME.common.truncate,
		':hover': {
			color: THEME.colors.text.main,
			textDecoration: 'underline',
		},
	},
	cardSelected: {
		borderColor: THEME.colors.primary.main,
		boxShadow: `0 0 0 1px ${THEME.colors.primary.main}`,
	},
	cardImage: {
		width: '100%',
		height: 120,
		objectFit: 'cover',
		display: 'block',
	},
	cardName: {
		padding: `${SPACE[4]}px ${SPACE[8]}px`,
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
		flex: 1,
		minWidth: 0,
		...THEME.common.truncate,
	},
	cardFooter: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: SPACE[4],
		// The caption is the flexible half; without this the truncation inside it never kicks in.
		minWidth: 0,
	},
	cardFolders: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: SPACE[4],
		padding: `0 ${SPACE[8]}px ${SPACE[8]}px`,
	},
	documentPreview: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		gap: SPACE[4],
		height: 120,
		width: '100%',
		backgroundColor: THEME.colors.background.main,
		color: THEME.colors.icon.gray,
	},
	documentExtension: {
		fontSize: THEME.typography.fontSizes.xxs,
		fontWeight: THEME.typography.fontWeights.bold,
		letterSpacing: 0.5,
		color: THEME.colors.text.light,
	},
	loadingContainer: {
		display: 'flex',
		justifyContent: 'center',
		padding: SPACE[32],
	},
	loadMoreTrigger: {
		display: 'flex',
		justifyContent: 'center',
		padding: SPACE[16],
	},
	emptyState: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		gap: SPACE[8],
		minHeight: 240,
		textAlign: 'center',
		padding: SPACE[32],
	},
	emptyStateTitle: {
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
	},
	emptyStateDescription: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
		maxWidth: 380,
	},
});
